import { Container, Grid } from "@mui/material";
import { useState } from "react";
import TopBar from "../../../components/TopBar/TopBar";
import Forms from "./Forms";
import TreatmentBundle from "./TreatmentBundle";
import TreatmentPlan from "./TreatmentPlan";
import VitalMaster from "./VitalMaster/VitalMaster";

const Plan = () => {
  const [selectedTab, setSelectedTab] = useState("TreatmentBundle");

  const handleSelectedTab = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <>
      <TopBar>
        <Container maxWidth="xl">
          <Grid container spacing={0}>
            <div className="flex-row">
              <div
                className="ph10pv3"
                onClick={() => {
                  handleSelectedTab("TreatmentBundle");
                }}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "TreatmentBundle"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Treatment Bundle
                </div>
              </div>
              <div
                className="ph10pv3"
                onClick={() => {
                  handleSelectedTab("Forms");
                }}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "Forms"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Consent Forms
                </div>
              </div>
              <div
                className="ph10pv3"
                onClick={() => handleSelectedTab("TreatmentPlan")}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "TreatmentPlan"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Protocol Forms
                </div>
              </div>
              <div
                className="ph10pv3"
                onClick={() => handleSelectedTab("Vitals")}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "Vitals"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Vitals
                </div>
              </div>
            </div>
          </Grid>
        </Container>
      </TopBar>
      <div className="left-con-white-wh mt10">
        {selectedTab === "TreatmentBundle" ? <TreatmentBundle /> : null}
        {selectedTab === "TreatmentPlan" ? <TreatmentPlan /> : null}
        {selectedTab === "Forms" ? <Forms /> : null}
        {selectedTab === "Vitals" ? <VitalMaster /> : null}
      </div>
    </>
  );
};

export default Plan;
